import { render, staticRenderFns } from "./VisualizationAxes.vue?vue&type=template&id=3c3a53ea&scoped=true&"
import script from "./VisualizationAxes.vue?vue&type=script&lang=js&"
export * from "./VisualizationAxes.vue?vue&type=script&lang=js&"
import style0 from "./VisualizationAxes.vue?vue&type=style&index=0&id=3c3a53ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a53ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VColorPicker,VMenu,VSelect})
